import React from "react";
import { Autocomplete } from "components/Autocomplete";
import { MultilineTextField } from "components/MultilineTextField";
import PropTypes from "prop-types";

export function FailureTypeField({ formik, failureTypes }) {
  return (
    <Autocomplete
      id="failure_mode_name"
      name="failure_mode_name"
      freeSolo
      disableClearable
      autoComplete
      autoHighlight
      fullWidth
      options={failureTypes?.map(({ name }) => name)}
      inputValue={formik.values.failure_mode_name}
      onInputChange={(_event, value) =>
        formik.setFieldValue("failure_mode_name", value)
      }
      renderInput={params => (
        <MultilineTextField
          {...params}
          value={formik.values.failure_mode_name}
          label="Failure Mode"
          error={
            formik.touched.failure_mode_name &&
            Boolean(formik.errors.failure_mode_name)
          }
          onChange={formik.handleChange}
          helperText={
            formik.touched.failure_mode_name && formik.errors.failure_mode_name
          }
          InputProps={{ ...params.InputProps }}
          data-qa="CP-Text-Failure-Mode"
        />
      )}
    />
  );
}

FailureTypeField.propTypes = {
  formik: PropTypes.object,
  failureTypes: PropTypes.arrayOf(PropTypes.object)
};
